// extracted by mini-css-extract-plugin
export default {"ModalBody":"RejectList_ModalBody__e0J1K"};